import * as React from 'react';
import { connect } from "react-redux";
import { Dispatch } from 'redux';
import { Prompt } from 'react-router';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Tabs, Button, Breadcrumb, Row, Col } from 'antd';
import { Route } from "antd/lib/breadcrumb/Breadcrumb";
const TabPane = Tabs.TabPane;

import { HeaderView } from 'src/app/shared/header.view';
import { ProductChildController } from './parts/product-child.controller';
import { ProductGeneralView } from './parts/product-general.view';
import { ProductChildrenController } from './parts/product-children.controller';
import { ProductContractsController } from './parts/product-contracts.controller';
import { ProductSupplementsController } from './parts/product-supplements.controller';
import { ProductItineraryController } from './parts/product-itinerary.controller';
import { ContractFormController } from 'src/app/products/contract/form/contract-form.controller';
import { AllotmentFormView } from 'src/app/products/allotment/form/allotment-form.view';
import { AllotmentRangeFormView } from 'src/app/products/allotment-range/form/allotment-range-form.view'
import { ToastNotifications } from 'src/core/ui/toast';
import { ErrataListController } from 'src/app/general/erratas/list/errata-list.controller';
import { ExtendedSchemaView } from 'src/core/ui/extended-schema.view';
import { ProductAvailabilitiesController } from 'src/app/products/products/form/parts/product-availabilities.controller';
import { TourItineraryFormController } from 'src/app/products/tour-itineraries/form/tour-itinerary.controller';
import { TourItineraryDateFormController } from 'src/app/products/tour-itineraries/tour-itinerary-date/form/tour-itinerary-date-form.controller';
import UserTaskTab from 'src/app/general/user-tasks/parts/user-tasks-tab.view';
import { ImageGalleryController } from 'src/app/products/image-gallery/image-gallery.controller';
import { ZuluIcon } from 'src/app/shared/icon';
import { actionCreators } from "src/store/products/product-form-nav-actions";
import * as moment from 'moment';
import { ContractDataService } from 'src/app/products/contract/form/contract-form.data';

interface PropsFromState {
	category?: ProductCategorySummary;
	currencies: CurrencySummary[];
}

interface PropsFromDispatch {
	navigateDown: (entity: any) => any;
}

type ContainerProps = PropsFromState & PropsFromDispatch;

interface Props extends ComponentViewProps<ProductItem> {
	title?: string,
	save?: () => void,
	cancel?: () => void,
	mode: ControlMode;
	onModeChanged?: (mode: ControlMode) => void;
	contextService: any;
	formatService: any;
	toast: ToastNotifications;
	productCodeRequired: boolean;
	defaultLanguage: string;
	identityService: any;
	schema: JsonSchema;
	breadcrumb?: ReadonlyArray<Readonly<BreadcrumbItem<ProductFormItemType>>>;
}

@observer
class ProductFormView extends React.Component<Props & ContainerProps, { userTaskCount: number }> {
	constructor(props: Readonly<Props & ContainerProps>) {
		super(props);

		this.state = {
			userTaskCount: 0
		}
	}

	private get hasExtendedProperties(): boolean {
		return this.props.schema.allOf != null && this.props.schema.allOf.length > 0 && Object.getOwnPropertyNames(this.props.schema.allOf[0].properties).length > 0;
	}

	@autobind
	private renderBreadcrumbItem(route: Route) {
		const { breadcrumb, navigateDown } = this.props;
		const item = breadcrumb.find(e => e.key === route.breadcrumbName && e.entity.id.toString() === route.path);
		return (
			<Button
				style={{ height: '100%' }}
				onClick={() => navigateDown(item)}
			>
				<span key="0">{item.title}</span>
				<ZuluIcon key="1" type="close" />
				<br key="2" />
				<span key="3">{item.text}</span>
			</Button>
		);
	}

	taskTab: UserTaskTab;

	public componentDidMount() {
		let daedline = moment.utc().add(1, "day").toDate();
		let assignedToId = this.props.identityService.userId;
		let priority = 1;
		let titleTask = "Task Title";
		this.taskTab = new UserTaskTab(this, this.props.model.id, 'product', this.props.setBusy, daedline, assignedToId, priority, titleTask);
	}

	render() {
		const { breadcrumb } = this.props;

		const latest = breadcrumb == null || breadcrumb.length == 1
			? null
			: breadcrumb[breadcrumb.length - 1];
		const previous = breadcrumb == null
			? null
			: breadcrumb[breadcrumb.length - 2];
		const breadcrumUI = breadcrumb == null || breadcrumb.length == 0
			? null
			: (
				<div className='card header'>
					<Breadcrumb
						className="m-1"
						separator={<ZuluIcon type='right' />}
						itemRender={this.renderBreadcrumbItem}
						routes={breadcrumb.map(e => ({
							path: e.entity.id.toString(),
							breadcrumbName: e.key,
						}))}
					/>
				</div>
			);
		let pivotArray: any[] = [];
		// Push Common Information, Content, Tags,
		pivotArray.push(
			<TabPane tab="Common information" key="Common information">
				<ProductGeneralView
					contextService={this.props.contextService}
					mode={this.props.mode}
					model={this.props.model}
					setBusy={this.props.setBusy}
					productCodeRequired={this.props.productCodeRequired}
				/>
			</TabPane>,
			<TabPane tab="Errata" key="Errata">
				<Row>
					<Col xs={24}>
						<ErrataListController
							model={this.props.model.dynamicProperties['erratas']}
							mode={this.props.mode}
							identityService={this.props.identityService}
							setBusy={this.props.setBusy}
						/>
					</Col>
				</Row>
			</TabPane>,
		);
		if (this.props.model.id > 0) {
			pivotArray.push(<TabPane tab="Images Gallery" key="ImagesGallery">
				{this.props.model &&
					<ImageGalleryController
						mode={this.props.mode}
						model={this.props.model.documentsLibraryId}
						setBusy={this.props.setBusy}
					/>}
			</TabPane>);
		}
		if (this.props.model.id > 0 && this.taskTab) {
			pivotArray.push(this.taskTab.render())
		}

		if (this.hasExtendedProperties && this.props.category) {
			pivotArray.splice(1, 0,
				<TabPane tab={<span> Other Properties</span>} key="Other Properties">
					<ExtendedSchemaView
						mode={this.props.mode}
						columns={2}
						validTaxonomies={this.props.category.taxonomicFields}
						model={this.props.model.dynamicProperties}
						schema={this.props.schema}
						setBusy={this.props.setBusy}
						title="Other Information"
					/>
				</TabPane>
			);
		}

		// push Children Tabs
		if (this.props.category && this.props.category.canHaveChildrenOfType != null)
			pivotArray.push(
				<TabPane tab={this.props.category != null && this.props.category.canHaveChildrenOfTypeText != null
					? this.props.category.canHaveChildrenOfTypeText + 's'
					: ''} key={this.props.category != null && this.props.category.canHaveChildrenOfTypeText != null
						? this.props.category.canHaveChildrenOfTypeText + 's' :
						''}>
					{
						this.props.category && this.props.category.canHaveChildrenOfType != null &&
						<ProductChildrenController
							mode={this.props.mode}
							defaultLanguage={this.props.defaultLanguage}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService}
						/>
					}
				</TabPane>
			);

		// push Supplements/Discounts
		if (this.props.category && this.props.category.canHaveSupplementsOrDiscounts)
			pivotArray.push(
				<TabPane tab='Supplements/Discounts' key="Supplements/Discounts" >
					{
						this.props.category && this.props.category.canHaveSupplementsOrDiscounts &&
						<ProductSupplementsController
							defaultLanguage={this.props.defaultLanguage}
							mode={this.props.mode}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService} />

					}
				</TabPane>
			);
		// push Contracts
		if (this.props.category && this.props.category.canHaveContracts && this.props.model.productType !== 9)
			pivotArray.push(
				<TabPane tab='Contracts' key="Contracts" >
					{
						this.props.category && this.props.category.canHaveContracts &&
						<ProductContractsController
							defaultLanguage={this.props.defaultLanguage}
							mode={this.props.mode}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService} />

					}
				</TabPane>
			);

		// push itineraries
		if (this.props.model.productType === 9)
			pivotArray.push(
				<TabPane tab='Itineraries' key="Itineraries" >
					{
						this.props.category &&
						<ProductItineraryController
							defaultLanguage={this.props.defaultLanguage}
							mode={this.props.mode}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService}
						/>
					}
				</TabPane>
			);

		pivotArray.push(<TabPane tab="Availability Allotments" key="Availability Allotments" >
			{<ProductAvailabilitiesController
				contextService={this.props.contextService}
				defaultLanguage={this.props.defaultLanguage}
				mode={this.props.mode}
				onModeChanged={this.props.onModeChanged}
				model={this.props.model}
				setBusy={this.props.setBusy}
			/>}
		</TabPane >)

		return (
			<div className="window window-normal">
				{breadcrumb == null || breadcrumb.length === 0 && this.renderPrompt()}
				{
					this.props.save && <Row>
						<Col xs={24}>
							<HeaderView
								title={this.props.title}
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								save={this.props.save}
								cancel={this.props.cancel}
								contextService={this.props.contextService}
							/>
						</Col>
						<Col xs={24}>
							{breadcrumUI}
						</Col>
					</Row>
				}

				{
					latest == null && this.props.model &&
					<Row>
						<Col xs={24}>
							<div className='card p-3'>
								<Tabs >
									{pivotArray}
								</Tabs>
							</div>
						</Col>
					</Row>
				}
				{
					latest != null && latest.key == 'contract' &&
					<ContractFormController
						isDirty={this.props.contextService.isDirty}
						identityService={this.props.identityService}
						mode={this.props.mode}
						onModeChanged={this.props.onModeChanged}
						setBusy={this.props.setBusy}
						formatService={this.props.formatService}
						contextService={this.props.contextService}
						model={latest.entity as ContractItem}
						product={previous.entity as (ProductItem | TourItineraryItem)}
						defaultLanguaje={this.props.defaultLanguage}
						currencies={this.props.currencies}
					/>
				}
				{
					latest != null && latest.key == 'sub-product' &&
					<ProductChildController
						defaultLanguage={this.props.defaultLanguage}
						identityService={this.props.identityService}
						toast={this.props.toast}
						mode={this.props.mode}
						model={latest.entity as ProductItem}
						parentProduct={previous.entity as ProductItem}
						setBusy={this.props.setBusy}
						contextService={this.props.contextService}
						formatService={this.props.formatService}
						schema={this.props.schema}
					/>
				}
				{
					latest != null && latest.key == 'sup-disc' &&
					<ProductChildController
						defaultLanguage={this.props.defaultLanguage}
						identityService={this.props.identityService}
						toast={this.props.toast}
						mode={this.props.mode}
						model={latest.entity as ProductItem}
						parentProduct={previous.entity as ProductItem}
						setBusy={this.props.setBusy}
						contextService={this.props.contextService}
						formatService={this.props.formatService}
						schema={this.props.schema}
					/>
				}
				{
					latest != null && latest.key == 'allotment' &&
					<AllotmentFormView
						defaultLanguaje={this.props.defaultLanguage}
						toast={this.props.toast}
						mode={this.props.mode}
						formatService={this.props.formatService}
						onModeChanged={this.props.onModeChanged}
						setBusy={this.props.setBusy}
						contextService={this.props.contextService}
						model={latest.entity as AllotmentItem}
						fromContract={true}
						fullscreen={true}
						productTypeText={this.props.model.productTypeText}
						categoryDisplayName={this.props.category.displayName}
						productDisplayName={this.props.title}
					/>
				}
				{
					latest != null && latest.key == 'allotmentRange' &&
					<Col xs={24}>
						<div className="card p-3">
							<AllotmentRangeFormView
								allotment={previous.entity as AllotmentItem}
								formatService={this.props.formatService}
								model={latest.entity as AllotmentRangeItem}
								contextService={this.props.contextService}
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								setBusy={this.props.setBusy}
							/>
						</div>
					</Col>
				}
				{
					latest != null && latest.key == 'itinerary' &&
					<TourItineraryFormController
						contextService={this.props.contextService}
						mode={this.props.mode}
						model={latest.entity as TourItineraryItem}
						product={previous.entity as ProductItem}
						setBusy={this.props.setBusy}
					/>
				}
				{
					latest != null && latest.key == 'itinerary-date' &&
					<TourItineraryDateFormController
						mode={this.props.mode}
						model={latest.entity as TourItineraryDateItem}
						itinerary={previous.entity as TourItineraryItem}
						setBusy={this.props.setBusy}
					/>
				}
			</div>
		);
	}

	private renderPrompt(): React.ReactNode {
		return (
			<Prompt
				when={this.props.contextService.isDirty}
				message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
			/>
		);
	}
}

const mapStateToProps = (state: IApplicationState, props: ComponentViewProps<ProductItem>): PropsFromState => {
	const product = state.otherLoadedEntities.find(e => e.entity == props.model.entity);
	return {
		category: product ? (product as ProductItem).category : undefined,
		currencies: state.currencies,
	};
};

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => {
	return {
		navigateDown: (entity) => dispatch(actionCreators.productFormDownNav(entity)),
	};
}

const connected = connect(
	mapStateToProps,
	mapDispatchToProps,
)(ProductFormView);
export { connected as ProductFormView };



// WEBPACK FOOTER //
// ./src/app/products/products/form/product-form.view.tsx